import { render, staticRenderFns } from "./OrgSettings.vue?vue&type=template&id=45d94f53&scoped=true"
import script from "./OrgSettings.vue?vue&type=script&lang=js"
export * from "./OrgSettings.vue?vue&type=script&lang=js"
import style0 from "./OrgSettings.vue?vue&type=style&index=0&id=45d94f53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d94f53",
  null
  
)

export default component.exports